import React, { useEffect, useState, useContext } from "react";
import SellerSidebar from "../../../navigation/sellerNavigation";
import { getData } from "../../../fetchRoutes/getData";
import PropertyCard from "../../../utility/propertyCard";
import { UserContext } from "../../../context/userContext";
import BuyerChat from "../chat/buyerChat";
import SellerMobileSidebar from "../../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../../context/deviceContext";

export default function FavoritePropertiesContainer() {

  const mySavedPropertiesUrl = process.env.REACT_APP_GET_FAVORITES_PROPERTIES;

  const { userDetails } = useContext(UserContext);
  const {isMobile}= useContext(DeviceContext);
  

  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [properties, setProperties] = useState([]);

  const [chatVisible, setChatVisible] = useState(false);
  const [selectedSellerId, setSelectedSellerId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const propertiesPerPage = 8;

  useEffect(() => {
    async function fetchProperties() {
      if (!mySavedPropertiesUrl) {
        setError("API URL is missing");
        setLoading(false);
        return;
      }

      try {
        const response = await getData(mySavedPropertiesUrl);
        if (response.status === "Success") {
          setProperties(response.data || []);
        } else {
          setError("No properties found.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchProperties();
  }, [mySavedPropertiesUrl]);

  const indexOfLast = currentPage * propertiesPerPage;
  const indexOfFirst = indexOfLast - propertiesPerPage;
  const currentProperties = properties.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(properties.length / propertiesPerPage);


  const handleContactSeller = (sellerId) => {
    setSelectedSellerId(sellerId);
    setChatVisible(true);
  };

  const closeChat = () => {
    setChatVisible(false);
    setSelectedSellerId(null);
  };


  return (
    <main className="sellerDashboard">
      {isMobile ? <SellerMobileSidebar/> :<SellerSidebar />}
      <div className={`container ${properties.length < 4 ? 'moreProperties' : ''}`}>
        <h1 className="containerTitle">FAVORITES</h1>

        <div className="propertyList">
          {error && <p className="errorMessage">{error}</p>}
          {!error && isLoading && <p className="loadingText">Loading properties...</p>}
          {!error && !isLoading && currentProperties.length > 0 ? (
            currentProperties.map((property) => (
              <PropertyCard
                key={property._id}
                property={property}
                favorite={true}
                secondButtonLabel="Contact seller"
                onSecondButtonClick={handleContactSeller}
              />
            ))
          ) : (
            !error && !isLoading && <p className="noPropertiesText">No properties found.</p>
          )}
        </div>

        {totalPages > 1 && (
          <div className="pagination">
            <button
              onClick={() => setCurrentPage((prev) => prev - 1)}
              disabled={currentPage === 1}
              className={`btnPagination ${currentPage === 1 ? 'disabled' : ''}`}
            >
              Previous
            </button>

            <span className="pageInfo">Page {currentPage} of {totalPages}</span>

            <button
              onClick={() => setCurrentPage((prev) => prev + 1)}
              disabled={currentPage === totalPages}
              className={`btnPagination ${currentPage === totalPages ? 'disabled' : ''}`}
            >
              Next
            </button>
          </div>
        )}
      </div>

        {chatVisible && selectedSellerId && (
            <div className="chatPopup">
                <BuyerChat
                sellerId={selectedSellerId}
                buyerId={userDetails._id}
                onClose={closeChat}
                />
            </div>
        )}
    </main>
  );
}
